import {
  Box,
  Button,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import { Edit } from "@material-ui/icons";
import FormattedMessage from "features/common/TranslatedMessage";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateDispute } from "slices/disputeSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "12px 15px",
    textAlign: "center",
    background: "#D7E1EE",
    borderRadius: "4px",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: "0.75rem",
  },
  empty: {
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    color: TEXT.muted,
    fontStyle: "italic",
  },
  item: {
    marginTop: theme.spacing(1),
    // flex: 1,
    width: "98%",
    borderRadius: "0.3rem",
    resize: "none",
    padding: theme.spacing(1),
    fontSize: "0.875rem",
    fontFamily: theme.typography.fontFamily,
    border: "1px solid #ccc",
    outline: "none",
  },
  text: {
    fontWeight: "500",
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    letterSpacing: "0.4px",
    color: TEXT.secondary,
    wordBreak: "break-all",
  },
}));

export default function Summary({ summary, caseId, isDisputeClosed }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [edit, setEdit] = useState(false);
  const [summaryText, setSummaryText] = useState(summary);
  const [savedText, setSavedText] = useState(summary);

  useEffect(() => {
    if (edit) return;
    setSummaryText(summary);
    setSavedText(summary);
  }, [summary]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    const summary = e.target.value.slice(0, 1000);
    setSummaryText(summary);
  };

  const onSubmit = () => {
    dispatch(
      updateDispute({
        id: caseId,
        summery: summaryText,
      })
    );
    setSavedText(summaryText);
    setEdit(false);
  };

  const onCancel = () => {
    setSummaryText(savedText);
    setEdit(false);
  };

  const element = (
    <TextareaAutosize
      data-testid={`1234213421343421`}
      data-question-type="textarea"
      required
      label="Required"
      onChange={handleChange}
      className={classes.item}
      value={summaryText}
      rowsMin={1}
      rowsMax={4}
      maxLength={2000}
    />
  );

  return (
    <Paper className={classes.paper}>
      <Grid container justify="space-between">
        <Grid item style={{ textAlign: "left" }}>
          <Typography className={classes.text} style={{fontSize: '1rem'}}>Summary (1000 characters)</Typography>
        </Grid>
        {!edit && (
          <Grid item>
            <Edit
              style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto", color: TEXT.secondary }}
              onClick={() => setEdit(true)}
            />
          </Grid>
        )}
      </Grid>
      <Grid container>
        {!edit ? (
          <Grid item style={{ textAlign: "left" }}>
            {summaryText ? (
              <Typography className={classes.text}>{summaryText}</Typography>
            ) : (
              <Typography className={classes.empty}>
                No summary added yet.
              </Typography>
            )}
          </Grid>
        ) : (
          <Grid item md={12} sm={12} xs={12} style={{ width: "100%" }}>
            {element}
            <Box height="0.75rem"></Box>
            <Box className={classes.actions}>
              <Button
                variant="contained"
                color="primary"
                onClick={onSubmit}
                size="small"
              >
                <FormattedMessage id="buttons.save" />
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={onCancel}
                size="small"
              >
                <FormattedMessage id="buttons.cancel" />
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}
